"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROPS_REQUIRE_RELOAD = void 0;
var PROPS_REQUIRE_RELOAD = ['folder', //images source
'filenameX', //images source
'filenameY', //images source
'apiVersion', //images source
'imageListX', //images source
'imageListY', //images source
'indexZeroBase', //images source
'lazySelector', //images source
'keys', // events
'stopAtEdges', // events
'disableDrag', // events
'controlReverse', // events
'disableDrag' // events
];
exports.PROPS_REQUIRE_RELOAD = PROPS_REQUIRE_RELOAD;